export default __webpack_public_path__ + "3b398da375fe433aed7f84c564086703.svg";